import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import * as yup from "yup";

export interface IDetectorActivityFormMeta {
    activeVibrationDetector: FormInputMeta;
    doorContactActive: FormInputMeta;
    silentSignal: FormInputMeta;
    electronicsEnclosureSensorActive: FormInputMeta;

}

const detectorActivityFormMeta = {} as IDetectorActivityFormMeta;

detectorActivityFormMeta.activeVibrationDetector = {
    name: "activeVibrationDetector",
    type: "checkbox",
    label: "Détecteur de Vibration Actif",
    placeholder: "",
    validation: yup.boolean()
};

detectorActivityFormMeta.doorContactActive = {
    name: "doorContactActive",
    type: "checkbox",
    label: "Contact de Porte Actif",
    placeholder: "",
    validation: yup.boolean()
};

detectorActivityFormMeta.silentSignal = {
    name: "silentSignal",
    type: "checkbox",
    label: "Silent Signal",
    placeholder: "",
    validation: yup.boolean()
};

detectorActivityFormMeta.electronicsEnclosureSensorActive = {
    name: "electronicsEnclosureSensorActive",
    type: "checkbox",
    label: "Electronics Enclosure Sensor Active",
    placeholder: "",
    validation: yup.boolean()
};


export default detectorActivityFormMeta;